module.exports = __webpack_public_path__ + "img/vulgar2.b3ecaa2c.jpg";